import React from 'react';
import { Lightbulb, AlertTriangle, TrendingUp, ArrowRight } from 'lucide-react';
import Surface from './Surface';
import { cn } from '../../utils/tailwindUtils';

const VARIANTS = {
  opportunity: {
    Icon: TrendingUp,
    tone: 'text-emerald-600 dark:text-emerald-400',
    iconBg: 'bg-emerald-100 dark:bg-emerald-950/40',
    label: 'Opportunity',
  },
  risk: {
    Icon: AlertTriangle,
    tone: 'text-rose-600 dark:text-rose-400',
    iconBg: 'bg-rose-100 dark:bg-rose-950/40',
    label: 'Risk',
  },
  insight: {
    Icon: Lightbulb,
    tone: 'text-amber-600 dark:text-amber-400',
    iconBg: 'bg-amber-100 dark:bg-amber-950/40',
    label: 'Insight',
  },
};

/**
 * "What does this mean? What should I do?" card.
 */
const InsightCard = ({ variant = 'insight', title, description, action, onAction, className }) => {
  const v = VARIANTS[variant] || VARIANTS.insight;
  const Icon = v.Icon;
  return (
    <Surface padding="md" className={cn('flex gap-3 items-start', className)}>
      <span className={cn('w-9 h-9 rounded-lg flex items-center justify-center shrink-0', v.iconBg, v.tone)}>
        <Icon className="w-4.5 h-4.5" />
      </span>
      <div className="flex-1 min-w-0">
        <div className={cn('text-[10px] font-semibold uppercase tracking-widest', v.tone)}>{v.label}</div>
        <h4 className="mt-0.5 text-sm font-semibold text-foreground leading-snug">{title}</h4>
        {description && (
          <p className="mt-1 text-xs text-muted-foreground leading-relaxed">{description}</p>
        )}
        {action && (
          <button
            onClick={onAction}
            className="mt-2 inline-flex items-center gap-1 text-[11px] font-semibold text-primary hover:underline"
          >
            {action} <ArrowRight className="w-3 h-3" />
          </button>
        )}
      </div>
    </Surface>
  );
};

export default InsightCard;
